import React, { useState } from 'react';
import {
  Button,
  Grid,
  Tooltip,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  DialogContent,
  DialogContentText,
  Dialog,
} from "@mui/material";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CommonDialog from 'components/commonDialog/CommonDialog';
import CommonImageModal from 'components/commonImageModal/CommonImageModal';
import { getDateFormat, truncateComment} from 'utils/utils';
import pdfImg from 'assets/images/pdfImg.svg';
import download from 'assets/images/download.png';
import CloudSyncOutlinedIcon from "@mui/icons-material/CloudSyncOutlined";
import ComplianceUpload from './ComplianceUpload';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import './Compliance.scss';
import { dateFormate } from 'utils/utils';

// Utility function to check if document is expiring soon (within 30 days)
const isSoonToExpire = (expiryDate) => {
  if (!expiryDate) return false;

  const currentDate = new Date();
  const expiry = new Date(expiryDate);
  const timeDifference = expiry.getTime() - currentDate.getTime();
  const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

  return daysDifference > 0 && daysDifference <= 30;
};

function ComplianceDocumentDetails(props) {
  const [open, setOpen] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const details = props?.details.length > 0 ? props?.details : [];
  const [selectedDocs, setSelectedDocs] = useState([])
  const [selectedImage,setSelectedImage] = useState('');
  const [selected, setSelected] = useState(false)
  const [rejectedDoc, setRejectedDoc] = useState(null);
  const [showUploadForm, setShowUploadForm] = useState(false);
  
  const handleCheckboxChange = (index, name) => {
    let newArray = [];
    let newObject = {
      placeholder: "Reject Reason",
      required: true,
      type: "textarea",
      name: "",
      label: "",
      multiline: true,
      row: 7,
    };
    newArray = selectedDocs;
    const idx = newArray.findIndex((data) => data.id == index);
    if (idx > -1) {
      newArray.splice(idx, 1);
      if (newArray?.length > 0) {
        setSelected(true);
      } else {
        setSelected(false);
      }
      setSelectedDocs(newArray);
    } else {
      newObject = {
        ...newObject,
        id: index,
        name: index,
        label: "Reject Reason(" + name + ")",
      };
      newArray.push(newObject);
      setSelected(true);
      setSelectedDocs(newArray);
    }
  };
  const handleRejectedButtonClick = (val) => {
    setOpen(true);
  };
  const handleApprovalButtonClick = (val) => {
    props?.onClickVerification(selectedDocs, val);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };
  const handleClose = () =>{
    setSelectedImage(null);
    setPreviewModal(false);
  }
  const handleOpen = (image) =>{
    setSelectedImage(image);
    setPreviewModal(true); 
  }
  const onDialog = (data) => {
    const val = data;
    handleApprovalButtonClick(val);
    setOpen(false);
  };

  const handleOnError = (e) => {
    e.target.src = pdfImg;
  };

  const filteredFiles = details?.filter((val) => val.attributeType === "File");
  const filteredImages = details?.filter(
    (val) =>
      val.attributeType === "Image" || val.attributeType === "Multi-Image"
  );
  const filteredTextDocuments = details?.filter(
    (val) => val.attributeType === "text"
  );

  const renderDocument = (document) => {
    const isSoonExpiring = isSoonToExpire(document?.expiryDate);

    const isDisabled =
      document?.status === "Approved" ||
      document?.status === "Rejected" ||
      document?.isExpired === true;

      let canReupload = false;
    if (props?.fromSubVendorExpiry) {
      canReupload = document?.status === "Rejected" || document?.isExpired === true || isSoonExpiring;
    } else {
      canReupload = document?.status === "Rejected";
    }

      const handleUpload = () => {
      setRejectedDoc({
        id: document.id,
        attributeName: document.complianceName,
        attributeType: document.attributeType,
        isMandatory: document.isMandatory,
        isExpiring: document.isExpiring ? true : false,
        complianceValue: [
          {
            id: document.id,
            status: document.status,
            atributeValue: document.atributeValue,
            expiryDate: document.expiryDate,
            complianceFile: document.complianceFile,
            rejectionReason: document.rejectionReason,
            isExpired: document.isExpired,
            isSoonExpiring: isSoonExpiring,
          },
        ],
      });
      setModalOpen(true);
      setShowUploadForm(true);
      setPreviewModal(false);
    };

    return (
      <Grid
        item
        md={3.7}
        sm={12}
        className="borderStyle padding10 m10"
        key={document.id}
        onClick={(e) =>{
          if (e.target.tagName.toLowerCase() !== 'input') {
           (document?.attributeType !== 'text' && 
           !document?.complianceFile?.name.includes('.pdf'))&& handleOpen(document?.complianceFile?.url)
          }
        }}
      >
        <div className={` ${document?.complianceFile?.name.includes(".pdf") ? "dlPdf" : "dlImgMain" }`}>
          <div className="dlImgBg"></div>
          <FormGroup className="formGrp">
            <FormControlLabel
              value="bottom"
              className="checkbox"
              control={
                document?.status === "Uploaded" && !props?.accessToApprove ? 
                <Checkbox
                  className={`checkBoxAlign ${
                    document?.status === "Approved" ||
                    document?.status === "Rejected" ||
                    document?.isExpired === true
                      ? "checkBoxColor"
                      : ""
                  }`}
                  onChange={() =>
                    handleCheckboxChange(document?.id, document?.complianceName)
                  }
                  disabled={isDisabled}
                /> :
                <></>
              }
              label={
                <div>
                  {document?.attributeType !== "text" ? (
                    <img
                      src={
                        document?.complianceFile?.name.includes(".pdf") &&
                        document?.complianceFile?.url
                          ? pdfImg
                          : document?.complianceFile?.url
                      }
                      alt="driving"
                      className="dlImg"
                      onError={handleOnError}
                    />
                  ) : null}
                </div>
              }
            />
          </FormGroup>
        </div>
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems={document?.attributeType === "text" && "center" }
          className={`padding10 height110 ${
            document?.attributeType === "text" ? "backgroundGrey" : null
          }`}
        >
          <Grid item xs={12}>
            <Tooltip title={document?.complianceName} placement="bottom">
              <Typography variant='body3' className="colorBlack fw600" >
                {truncateComment(document?.complianceName, 20)}
              </Typography>
            </Tooltip>
            {document?.isMandatory && <Typography variant='body3' className="colorRed" >
              *
            </Typography>}
            {document?.atributeValue && (
              <p className="font12 fontNormal colorGrey">
                Number: {document?.atributeValue}
              </p>
            )}
            {document?.expiryDate && (
              <p
                className={`font12 fontNormal ${
                  isSoonExpiring && props?.fromSubVendorExpiry ? "colorOrange" : "colorBlueCompliance"
                }`}
              >
                <span
                  className={
                    isSoonExpiring && props?.fromSubVendorExpiry ? "colorOrange" : "colorBlueCompliance"
                  }
                >
                  Exp:&nbsp;
                </span>
                {dateFormate(document?.expiryDate, "DD MMMM YYYY")}
                {isSoonExpiring && props?.fromSubVendorExpiry && (() => {
                  const currentDate = new Date();
                  const expiry = new Date(document?.expiryDate);
                  const daysLeft = Math.ceil(
                    (expiry.getTime() - currentDate.getTime()) / (1000 * 3600 * 24)
                  );
                  return (
                    <span className="colorRed"> ({daysLeft} days left)</span>
                  );
                })()}
              </p>
            )}
          </Grid>

          <Grid item xs={12} container direction="row" justifyContent="space-between" alignItems="center" className="reuploadWrapper">
            <div>
              {document?.status && document?.isExpired !== true && !(isSoonExpiring && props?.fromSubVendorExpiry) && (
                <Tooltip title={document?.rejectionReason}>
                  <Typography
                    className={` ${
                      document?.status.toLowerCase() + "Status"
                    } flexAlignCenter cursorDefault`}
                    style={{fontSize: '1rem'}}
                  >
                    {document.status === "Rejected" && (
                      <ErrorOutlineIcon className="mr6 font16" />
                    )}
                    {document?.status}
                  </Typography>
                </Tooltip>
              )}

              {isSoonExpiring && !document?.isExpired && props?.fromSubVendorExpiry && (
                <Typography className="colorOrangeText flexDirection cursorDefault" style={{fontSize:'1rem', display: 'flex', alignItems: 'center', gap: '4px'}}>
                  Soon to Expire
                  <span style={{fontSize: '0.875rem'}} className="text-gray-500">
                    (
                    {document.status === "Rejected" && (<ErrorOutlineIcon className="marginRight3 font16" style={{marginRight: '3px'}}/>)}
                    {document?.status}
                    )
                  </span>
                </Typography>
              )}

              {document?.isExpired === true && (
                <Typography className=" colorRed flexDirection cursorDefault" style={{fontSize:'1rem'}}>
                  Expired (<span className="text-sm text-gray-500"><Tooltip>{document.status === "Rejected" && (<ErrorOutlineIcon className="marginRight3 font16" />)}</Tooltip>{document?.status}</span>)
                </Typography>
              )}

              <div className="flex flex-row">
                {document?.attributeType === "text" ? (
                  ""
                ) : (
                  <div className="colorGrey textCenter mt-4">
                    {document?.complianceFile?.size}
                    <span>
                      <a
                        href={document?.complianceFile?.url}
                        download={document?.complianceFile?.name}
                      >
                        <img src={download} alt="download icon" />
                      </a>
                    </span>
                  </div>
                )}
              </div>
            </div>

            {canReupload && (
              <CloudSyncOutlinedIcon
                onClick={(e) =>{
                  e.stopPropagation();
                  handleUpload()
                }}
                className="reuploadIcon"
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <div>
      {filteredFiles?.length > 0 && (
        <Typography className="mb20 padding10 font18">
          Text With File Documents
        </Typography>
      )}
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="start"
      >
        {details?.map((document, idx) => {
          if (document?.attributeType === "File") {
            return renderDocument(document);
          }
          return null;
        })}
      </Grid>

      {filteredFiles?.length > 0 && <div className="dashedborder"></div>}

      {/* ---Text View--- */}
      {filteredTextDocuments?.length > 0 && (
        <Typography className="mb20 padding10 font18">
          Text Documents
        </Typography>
      )}
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="start"
      >
        {details?.map((document, idx) => {
          if (document?.attributeType === "text") {
            return renderDocument(document);
          }
          return null;
        })}
      </Grid>

      {/* ---Image Section--- */}
      {filteredTextDocuments?.length > 0 && (
        <div className="dashedborder"></div>
      )}
      {filteredImages?.length > 0 && (
        <Typography className="mb20 padding10 font18">
          Text With Multi-Image
        </Typography>
      )}
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="start"
      >
        {details?.map((document, idx) => {
          if (
            document?.attributeType === "Image" ||
            document?.attributeType === "Multi-Image"
          ) {
            return renderDocument(document);
          }
          return null;
        })}
      </Grid>
      
      {!props?.accessToApprove && 
      <Grid
        container
        justifyContent="flex-end"
        direction="row"
        Spacing={2}
        className="buttonColor"
      >
        {details?.length > 0 && (
          <Grid item Spacing={2}>
            <Button
              className="buttonRed"
              variant="contained"
              disabled={selected ? false : true}
              onClick={() => handleRejectedButtonClick("rejcted")}
            >
              Reject
            </Button>
          </Grid>
        )}

        {details?.length > 0 && (
          <Grid item>
            <Button
              className="buttonGreen"
              variant="contained"
              disabled={selected ? false : true}
              onClick={() => handleApprovalButtonClick({ status: "accepted" })}
            >
              Approve
            </Button>
          </Grid>
        )}
      </Grid>}
    {previewModal && <CommonImageModal
        open={previewModal}
        handleClose={handleClose}
        selectedImage={selectedImage}
    />
       } 
      {open && <CommonDialog className='marginbottom20'
        open={open}
        handleClose={() => setOpen(false)}
        formData={selectedDocs}
        button={'dialogButton'}
        onSubmittBtn={onDialog}
        selectType={'Send'}
      />}


      {isModalOpen && (
       <Dialog
          open={isModalOpen}
          onClose={handleModalClose}
          aria-labelledby="compliance-upload-dialog"
        >
          <DialogContent>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <IconButton
                  edge="end"
                  color="inherit"
                  onClick={handleModalClose}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
            <DialogContentText>
              <ComplianceUpload
                details={[rejectedDoc]}
                tabName="document"
                reupload={true}
                fromSubVendorExpiry={props?.fromSubVendorExpiry}
                onSuccess={() => {
                  setShowUploadForm(false);
                  props?.handleReUploadStatus();
                  setRejectedDoc(null);
                  handleModalClose();
                  if (props.onDocumentUpdate) {
                    props.onDocumentUpdate();
                  }
                }}
              />
            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}

export default ComplianceDocumentDetails;
